<mat-sidenav-container class="sidenav-container staff-layout">

  <mat-sidenav-content>
    <mat-toolbar class="mat-elevation-z6" color="primary">
      <button mat-icon-button routerLink="/dashboard" type="button">
        <img alt="" class="w-100 me-2" src="/assets/images/emblem.webp">
        <span>{{ 'app-short-name' | translate | uppercase}}</span>
      </button>

      <span class="spacer"></span>

      <app-main-toolbar></app-main-toolbar>

    </mat-toolbar>

    <div class="content-navigations col-md-12" id="scrollbarTopStyle">
      @for (menuItem of mainMenu; track menuItem) {
        <ng-container *ngxPermissionsOnly="menuItem.permissions">
          @if (menuItem?.userType === loggedInUserType) {
            <a class="nav-buttons me-2"
              routerLink="{{ menuItem.route }}" routerLinkActive="active-top-menu">
              @if (menuItem.iconType === 'SVG') {
                <mat-icon svgIcon="{{ menuItem.icon }}"></mat-icon>
              }
              @if (menuItem?.iconType === 'MATERIAL') {
                <span class="material-symbols-outlined">{{menuItem?.icon}}</span>
              }
              <span>{{ menuItem.name | translate }}</span>
            </a>
          }
        </ng-container>
      }
    </div>

    <div class="top-120 container staff-main py-3 shadow-sm">
      <router-outlet></router-outlet>
    </div>

  </mat-sidenav-content>
</mat-sidenav-container>
